import React, { Component } from 'react';
import Select from "react-select";
import Swal from "sweetalert2/dist/sweetalert2.js";

// Debe reflejar FormatCalendarConfig::COMPATIBLE_TYPES (backend autoritativo).
const ROLES = [
    { key: "date_start", label: "Fecha inicio", required: true, types: ["answer_date", "answer_datetime", "answer_autdatetime"] },
    { key: "date_end", label: "Fecha fin", types: ["answer_date", "answer_datetime", "answer_autdatetime"] },
    { key: "time_start", label: "Hora inicio", types: ["answer_time", "answer_hour"] },
    { key: "time_end", label: "Hora fin", types: ["answer_time", "answer_hour"] },
    { key: "status", label: "Estado", types: ["answer_select", "answer_radio"] },
    { key: "responsible", label: "Responsable", types: ["answer_user_id", "answer_string"] },
    { key: "title", label: "Título", types: ["answer_string", "answer_text", "answer_integer", "code_format"] },
];

class Index extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = { isLoaded: true, config: null, questions: [], dirty: false };
    }

    componentDidMount() {
        this.loadConfig();
    }

    loadConfig = () => {
        this.setState({ isLoaded: true });
        fetch(`/formatos/get_format_calendar_config/${this.props.format.id}`, {
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
            .then(r => r.json())
            .then(data => this.setState({ config: data.config, questions: data.questions || [], isLoaded: false }));
    }

    patch = (body) => {
        fetch(`/formatos/format_calendar_configs/${this.state.config.id}`, {
            method: "PATCH",
            body: JSON.stringify(body),
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
            .then(r => r.json())
            .then(data => {
                this.toast(data);
                if (data.type !== "error") { this.setState({ dirty: false }); this.loadConfig(); }
            });
    }

    // Guarda TODOS los roles + colores + vista por defecto en un solo PATCH.
    saveAll = () => {
        const c = this.state.config;
        const body = { status_colors: c.status_colors || {}, default_view: c.default_view || "list" };
        ROLES.forEach(r => { body[`${r.key}_question_id`] = c.roles[r.key] ? c.roles[r.key].id : null; });
        this.patch(body);
    }

    // Descartar cambios pendientes → recargar desde el servidor.
    discard = () => { this.setState({ dirty: false }); this.loadConfig(); }

    // Notificación sutil (toast arriba a la derecha) en vez de un modal centrado.
    toast = (data) => {
        Swal.fire({
            toast: true,
            position: "top-end",
            type: data.type,
            title: data.success,
            showConfirmButton: false,
            timer: 1800,
            timerProgressBar: true,
        });
    }

    questionOptions = (types) =>
        this.state.questions.filter(q => types.includes(q.type)).map(q => ({ value: q.id, label: q.name }));

    roleValue = (key) => {
        const r = this.state.config.roles[key];
        return r ? { value: r.id, label: r.name } : null;
    }

    // Los cambios son LOCALES (no guardan al instante) → se marca dirty y el
    // usuario guarda con el botón. Evita la recarga/flicker por cada cambio.
    onRoleChange = (key, opt) => {
        const roles = { ...this.state.config.roles, [key]: opt ? { id: opt.value, name: opt.label } : null };
        this.setState({ config: { ...this.state.config, roles }, dirty: true });
    }

    onColorChange = (option, color) => {
        const status_colors = { ...(this.state.config.status_colors || {}), [option]: color };
        this.setState({ config: { ...this.state.config, status_colors }, dirty: true });
    }

    render() {
        const { config, isLoaded } = this.state;
        if (isLoaded || !config) return <div className="p-3 text-center text-muted">Cargando...</div>;

        return (
            <div className="row p-3">
                <div className="col-md-12">
                    <h5 className='ui-index-configurationFormat-subtitle-tab'>Vista calendario</h5>

                    <div className="custom-control custom-switch mt-2 mb-3">
                        <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCalendarEnabled"
                            checked={!!config.enabled}
                            onChange={() => this.patch({ enabled: !config.enabled })}
                        />
                        <label className="custom-control-label" htmlFor="customCalendarEnabled">
                            Habilitar una vista calendario para los registros de este formato.
                        </label>
                    </div>

                    {config.enabled && this.state.dirty && (
                        <div className="alert alert-info d-flex align-items-center justify-content-between" style={{ fontSize: 13, padding: "8px 12px" }}>
                            <span><i className="fas fa-info-circle mr-1"></i> Tienes cambios sin guardar.</span>
                            <span>
                                <button className="btn btn-sm btn-outline-secondary mr-2" onClick={this.discard}>Descartar</button>
                                <button className="btn btn-sm btn-primary" onClick={this.saveAll}>
                                    <i className="fas fa-save mr-1"></i> Guardar cambios
                                </button>
                            </span>
                        </div>
                    )}

                    {config.enabled && !config.roles.date_start && (
                        <div className="alert alert-warning" style={{ fontSize: 13 }}>
                            <i className="fas fa-exclamation-triangle mr-1"></i>
                            Asigná la <b>Fecha inicio</b> para que el calendario muestre eventos.
                        </div>
                    )}

                    {config.enabled && (
                        <div className="form-group" style={{ maxWidth: 360 }}>
                            <label style={{ fontWeight: 600, fontSize: 13 }}>Vista por defecto de los registros</label>
                            <select
                                className="form-control form-control-sm"
                                value={config.default_view || "list"}
                                onChange={(e) => this.setState({ config: { ...config, default_view: e.target.value }, dirty: true })}
                            >
                                <option value="list">Lista (tabla)</option>
                                <option value="calendar">Calendario</option>
                            </select>
                            <small className="text-muted">
                                Al abrir los registros de este formato se mostrará primero esta vista. Siempre podrás alternar entre lista y calendario.
                            </small>
                        </div>
                    )}

                    {config.enabled && (
                        <React.Fragment>
                            <p className="text-muted" style={{ fontSize: 12 }}>
                                Asigná qué campo del formato alimenta cada rol del calendario. La fecha de inicio es obligatoria.
                            </p>
                            <table className="table table-sm">
                                <thead>
                                    <tr><th style={{ width: "35%" }}>Rol del calendario</th><th>Pregunta del formato</th></tr>
                                </thead>
                                <tbody>
                                    {ROLES.map(role => (
                                        <tr key={role.key}>
                                            <td style={{ verticalAlign: "middle", fontWeight: 600 }}>
                                                {role.label}{role.required && <span className="text-danger"> *</span>}
                                            </td>
                                            <td>
                                                <Select
                                                    options={this.questionOptions(role.types)}
                                                    value={this.roleValue(role.key)}
                                                    onChange={(opt) => this.onRoleChange(role.key, opt)}
                                                    placeholder="Sin asignar"
                                                    className="link-form"
                                                    isClearable={!role.required}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {config.roles.status && config.status_options && config.status_options.length > 0 && (
                                <React.Fragment>
                                    <h6 className="mt-4" style={{ fontWeight: 700 }}>Color por estado</h6>
                                    <table className="table table-sm" style={{ maxWidth: 360 }}>
                                        <tbody>
                                            {config.status_options.map(option => (
                                                <tr key={option}>
                                                    <td style={{ verticalAlign: "middle" }}>{option}</td>
                                                    <td style={{ width: 70 }}>
                                                        <input
                                                            type="color"
                                                            value={(config.status_colors || {})[option] || "#2497c9"}
                                                            onChange={(e) => this.onColorChange(option, e.target.value)}
                                                            style={{ width: 48, height: 32, border: "none", background: "none", cursor: "pointer" }}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </React.Fragment>
                            )}

                            <a
                                href={`/formatos/records/${this.props.format.id}/calendar`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-outline-info mt-2"
                            >
                                <i className="fas fa-external-link-alt mr-1"></i> Abrir vista calendario
                            </a>
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }
}

export default Index;
